// extracted by mini-css-extract-plugin
export var contentBody = "_br-9";
export var headerImage = "_br-2";
export var imageButton = "_br-7";
export var imageButtonIcon = "_br-8";
export var imageHeader = "_br-4";
export var imageHeaderText = "_br-5";
export var imageOverlay = "_br-3";
export var imageTitle = "_br-6";
export var imageWrapper = "_br-1";
export var taskList = "_br-a";
export var widget = "_br-0";